import { PersonasPage } from "@/components/personas/personas-page.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/personas/")({
	component: PersonasSettingsPage,
	head: () => ({
		meta: [{ title: pageTitle(m.navigation_personas()) }],
	}),
});

function PersonasSettingsPage() {
	return <PersonasPage showHeader={false} />;
}
